<template>
  
    <div @click="clicked" :class="clase" :style="{width: width, height:heigth, position: position, top:top, left:left }"> 
      <p v-if="showTitle">{{titulo}}</p>
    </div>
  
</template>
<script>
export default {
    mounted () {
        console.log("Zona montada");
    },data() {
        return {
             esIframe:false
        }
    },

    props: {
        showTitle:{
            type:Boolean,
            default:false
        },
        estado: Boolean,
        heigth: String,
        width: String,
        position: String,
        top:String,
        left: String,
        titulo: String,
        tipo: {
            type:String,
            default:'estado'
        }
       
    },
    computed: {
        clase() {
            if(this.tipo=='estado') return (this.estado) ? 'ko' :'ok';
            else{
                return 'iframe';
            }
        },
       
    },
    methods: {
        clicked() {
           this.$emit('click');
           
        }
    },
    
}
</script>
<style scoped>
.image-fit{
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.ok{
  border-style: solid;

    background-color:rgba(0, 255, 0,0.5);
    border-color:rgb(0, 255, 0);
}
.ko{
  border-style: solid;

    background-color:rgba(255, 0, 0, 0.5);
    border-color:rgb(255, 0, 0);
}
.iframe{
    cursor: pointer;
    border-style: solid;
    background-color:rgba(180, 189, 230, 0.5);
    border-color:rgb(70, 34, 170);
}

    
</style>